// Author liang gang qiang
// Date 2021-12-08 11:19:20

class MintalMesPrdMonthPlan {
constructor({
        id = null,
        locationId = '',
        locationName = '',
        materialId = '',
        materialName = '',
        code = '',
        month = '',
        output = '',
        operationRate = '',
        status = '',
        qualitySpe1 = '',
        qualitySpe2 = '',
        remark = '',
        attachments = '',
        attachmentsList = ''}
= {}) {
    this.id = id;
    this.locationId = locationId;
    this.locationName = locationName;
    this.materialId = materialId;
    this.materialName = materialName;
    this.code = code;
    this.month = month;
    this.output = output;
    this.operationRate = operationRate;
    this.status = status;
    this.qualitySpe1 = qualitySpe1;
    this.qualitySpe2 = qualitySpe2;
    this.remark = remark;
    this.attachments = attachments;
    this.attachmentsList = attachmentsList;
}
}

function newEntity() {
return new MintalMesPrdMonthPlan();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'month',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.month',
        sortable: true,
        form: {
        type: 'year_month'
        }
        },
        {
        key: 'output',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.output',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationRate',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.operationRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualitySpe1',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.qualitySpe1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualitySpe2',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.qualitySpe2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'attachmentsList',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.grid.attachmentsList',
        sortable: true,
        form: {
        type: 'emAttachment'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    locationIdFilter : '',
    locationNameFilter : '',
    materialIdFilter : '',
    materialNameFilter : '',
    codeFilter : '',
    monthRteFilter : '',
    monthLteFilter : '',
    outputFilter : '',
    operationRateFilter : '',
    statusFilter : '',
    qualitySpe1Filter : '',
    qualitySpe2Filter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'locationNameFilter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.locationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'materialNameFilter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.materialName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstMaterial'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"materialId": "id"}'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'monthRteFilter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.monthRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'monthLteFilter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.monthLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'outputFilter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.output',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'operationRateFilter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.operationRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.status',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualitySpe1Filter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.qualitySpe1',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'qualitySpe2Filter',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.filter.qualitySpe2',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.locationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.materialName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstMaterial'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"materialId": "id"}'
                }
        },
        {
        key: 'month',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.month',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
            ,required: true
                }
        },
        {
        key: 'output',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.output',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'operationRate',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.operationRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualitySpe1',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.qualitySpe1',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'qualitySpe2',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.qualitySpe2',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'attachmentsList',
        label: 'label.mintal.prd.mintalMesPrdMonthPlan.entity.attachments',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'attachments'
                }
        }
]

export {MintalMesPrdMonthPlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
